import { Instagram, Mail, MapPin, Phone, Heart, Facebook } from "lucide-react";
import { Link } from "react-router-dom";
import { useSettings } from "../contexts/SettingsContext";
import { useMemo } from "react";

// ─── Service Categories (from mock data) ───────────────────────────────
const services = [
  "Henna Wedding",
  "Henna Pagar Ayu & Bridesmaid",
  "Henna Prewedding",
  "Henna Engagement",
  "Henna Graduation",
  "Fun Henna / Bridal Family",
];

// ─── SVG Henna Pattern (repeating background) ──────────────────────────
// A 300x300 tile with mandala flower, paisley motifs, vines, and dotwork
// at very low opacity for a subtle embroidered textile feel.
// Uses hex color #D4AF7A — encodeURIComponent will handle the # encoding.
const HENNA_PATTERN = `<svg xmlns="http://www.w3.org/2000/svg" width="300" height="300">
  <g fill="none" stroke="#D4AF7A" opacity="0.25" stroke-width="0.7">
    <circle cx="150" cy="150" r="48" opacity="0.6"/>
    <circle cx="150" cy="150" r="38" stroke-width="0.5" opacity="0.5"/>
    <path d="M150,102 Q172,130 150,150 Q128,130 150,102"/>
    <path d="M198,150 Q170,172 150,150 Q170,128 198,150"/>
    <path d="M150,198 Q128,170 150,150 Q172,170 150,198"/>
    <path d="M102,150 Q130,128 150,150 Q130,172 102,150"/>
    <path d="M184,116 Q174,142 150,150 Q174,158 184,116"/>
    <path d="M184,184 Q158,174 150,150 Q158,126 184,184"/>
    <path d="M116,184 Q126,158 150,150 Q126,142 116,184"/>
    <path d="M116,116 Q142,126 150,150 Q142,174 116,116"/>
    <circle cx="150" cy="150" r="22" stroke-width="0.4" opacity="0.4"/>
    <circle cx="150" cy="150" r="13" stroke-width="0.6" opacity="0.6"/>
    <circle cx="150" cy="150" r="3" fill="#D4AF7A" opacity="0.6"/>
  </g>
  <g fill="none" stroke="#D4AF7A" opacity="0.18" stroke-width="0.6">
    <path d="M48,48 C60,26 82,28 88,50 C93,68 76,80 64,74 C52,68 42,58 48,48"/>
    <path d="M58,46 C64,37 76,38 80,48 C82,56 73,62 64,60 C55,57 53,50 58,46" stroke-width="0.4" opacity="0.12"/>
    <path d="M66,54 C68,50 74,50 76,54 C78,58 72,60 66,54" stroke-width="0.4" opacity="0.14"/>
    <circle cx="66" cy="55" r="1.5" fill="#D4AF7A" opacity="0.18"/>
  </g>
  <g fill="none" stroke="#D4AF7A" opacity="0.18" stroke-width="0.6">
    <path d="M252,252 C240,274 218,272 212,250 C207,232 224,220 236,226 C248,232 258,242 252,252"/>
    <path d="M242,254 C236,263 224,262 220,252 C218,244 227,238 236,240 C245,243 247,250 242,254" stroke-width="0.4" opacity="0.12"/>
    <path d="M234,246 C232,250 226,250 224,246 C222,242 228,240 234,246" stroke-width="0.4" opacity="0.14"/>
    <circle cx="234" cy="245" r="1.5" fill="#D4AF7A" opacity="0.18"/>
  </g>
  <g fill="none" stroke="#D4AF7A" opacity="0.14" stroke-width="0.5">
    <path d="M258,48 Q276,36 294,48 Q282,66 258,48"/>
    <path d="M262,52 Q274,42 288,52 Q280,62 262,52" stroke-width="0.3" opacity="0.08"/>
    <path d="M42,252 Q24,264 6,252 Q18,234 42,252"/>
    <path d="M38,248 Q26,258 12,248 Q20,238 38,248" stroke-width="0.3" opacity="0.08"/>
    <path d="M258,258 Q276,270 294,258 Q282,276 258,258" stroke-width="0.3" opacity="0.08"/>
    <path d="M42,48 Q24,36 6,48 Q18,30 42,48" stroke-width="0.3" opacity="0.08"/>
  </g>
  <g fill="none" stroke="#D4AF7A" opacity="0.1" stroke-width="0.5">
    <path d="M86,62 Q110,82 128,118"/>
    <path d="M214,238 Q190,218 172,182"/>
    <path d="M256,88 Q234,112 196,140"/>
    <path d="M44,212 Q66,188 104,160"/>
    <path d="M86,238 Q112,218 130,190"/>
    <path d="M214,62 Q190,82 174,112"/>
  </g>
  <g fill="#D4AF7A" opacity="0.2">
    <circle cx="150" cy="88" r="2"/>
    <circle cx="142" cy="92" r="1.4"/>
    <circle cx="158" cy="92" r="1.4"/>
    <circle cx="150" cy="212" r="2"/>
    <circle cx="142" cy="208" r="1.4"/>
    <circle cx="158" cy="208" r="1.4"/>
    <circle cx="88" cy="150" r="2"/>
    <circle cx="92" cy="142" r="1.4"/>
    <circle cx="92" cy="158" r="1.4"/>
    <circle cx="212" cy="150" r="2"/>
    <circle cx="208" cy="142" r="1.4"/>
    <circle cx="208" cy="158" r="1.4"/>
  </g>
  <g fill="#D4AF7A" opacity="0.14">
    <circle cx="285" cy="28" r="1.4"/>
    <circle cx="290" cy="22" r="1"/>
    <circle cx="15" cy="272" r="1.4"/>
    <circle cx="10" cy="278" r="1"/>
    <circle cx="272" cy="285" r="1.4"/>
    <circle cx="278" cy="290" r="1"/>
    <circle cx="28" cy="15" r="1.4"/>
    <circle cx="22" cy="10" r="1"/>
    <circle cx="275" cy="15" r="1"/>
    <circle cx="15" cy="285" r="1"/>
  </g>
  <g fill="none" stroke="#D4AF7A" opacity="0.1" stroke-width="0.45">
    <path d="M194,108 Q204,96 214,108 Q220,118 208,124"/>
    <path d="M106,192 Q96,204 86,192 Q80,182 92,176"/>
    <path d="M194,192 Q204,204 214,192 Q220,182 208,176"/>
    <path d="M106,108 Q96,96 86,108 Q80,118 92,124"/>
  </g>
</svg>`;

// ─── Corner Filigree SVG (for top-left and top-right corners) ──────────
const CORNER_FILIGREE = (side) => {
  const isLeft = side === "left";
  return `<svg xmlns="http://www.w3.org/2000/svg" width="120" height="60" viewBox="0 0 120 60">
    <g fill="none" stroke="#D4AF7A" stroke-width="0.8" opacity="0.15">
      ${
        isLeft
          ? `
        <path d="M0,0 L0,40 C0,50 10,55 20,50 L120,18" stroke-width="0.6"/>
        <path d="M0,0 L0,30 C0,38 6,42 14,38 L80,14" stroke-width="0.4" opacity="0.5"/>
        <path d="M0,8 C10,6 20,10 25,18 C30,26 25,32 18,34" stroke-width="0.5"/>
        <circle cx="12" cy="22" r="2.5" fill="#D4AF7A" opacity="0.15"/>
        <circle cx="8" cy="36" r="1.5" fill="#D4AF7A" opacity="0.1"/>
        <circle cx="0" cy="15" r="1" fill="#D4AF7A" opacity="0.1"/>
      `
          : `
        <path d="M120,0 L120,40 C120,50 110,55 100,50 L0,18" stroke-width="0.6"/>
        <path d="M120,0 L120,30 C120,38 114,42 106,38 L40,14" stroke-width="0.4" opacity="0.5"/>
        <path d="M120,8 C110,6 100,10 95,18 C90,26 95,32 102,34" stroke-width="0.5"/>
        <circle cx="108" cy="22" r="2.5" fill="#D4AF7A" opacity="0.15"/>
        <circle cx="112" cy="36" r="1.5" fill="#D4AF7A" opacity="0.1"/>
        <circle cx="120" cy="15" r="1" fill="#D4AF7A" opacity="0.1"/>
      `
      }
    </g>
  </svg>`;
};

const Footer = () => {
  const { contactInfo, socialMedia, sectionSettings } = useSettings();

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }
  };

  const allQuickLinks = [
    { label: "Beranda", id: "home" },
    { label: "Tentang", id: "about", setting: "about" },
    { label: "Layanan", id: "services", setting: "services" },
    { label: "Galeri", id: "gallery", setting: "gallery" },
    { label: "Testimoni", id: "testimonials", setting: "testimonials" },
    { label: "Kontak", id: "contact", setting: "contact" },
  ];

  const quickLinks = useMemo(() => {
    return allQuickLinks.filter((link) => {
      if (link.id === "home") return true;
      return link.setting && sectionSettings[link.setting] !== false;
    });
  }, [sectionSettings]);

  return (
    <footer className="relative bg-gradient-to-b from-black via-[#050505] to-black overflow-hidden">
      {/* ── Henna Pattern Background ── */}
      <div
        className="absolute inset-0 pointer-events-none opacity-90"
        style={{
          backgroundImage: `url("data:image/svg+xml,${encodeURIComponent(HENNA_PATTERN)}")`,
          backgroundSize: "300px 300px",
          backgroundRepeat: "repeat",
        }}
        aria-hidden="true"
      />

      {/* ── Main Content ── */}
      <div className="relative z-10 px-4 pt-20 pb-16 mx-auto max-w-7xl sm:px-6 lg:px-8">
        {/* ── 4-Column Grid ── */}
        <div className="grid gap-10 mb-14 sm:grid-cols-2 lg:grid-cols-[1.3fr_1fr_1.2fr_1.3fr]">
          {/* ═══ Brand & Social ═══ */}
          <div className="space-y-6">
            <div className="flex items-center gap-4">
              <div className="relative flex-shrink-0">
                <div className="absolute inset-0 w-16 h-16 bg-[#D4AF7A]/20 rounded-full blur-xl" />
                <img
                  src="./logo512.png"
                  alt="Putri Henna Artist"
                  className="relative w-auto h-16 drop-shadow-[0_0_12px_rgba(212,175,122,0.4)]"
                />
              </div>
              <div>
                <h3 className="text-xl md:text-2xl font-bold text-[#D4AF7A] tracking-wide">
                  Teh Putri
                </h3>
                <p className="text-xs md:text-sm text-[#F7F5F2] tracking-[0.15em] uppercase">
                  Henna Artist
                </p>
              </div>
            </div>

            <p className="text-sm md:text-base text-[#F7F5F2]/60 leading-relaxed max-w-xs">
              Layanan henna profesional dengan design eksklusif untuk momen
              spesial Anda. Bahan natural, hasil memukau.
            </p>

            <div className="flex gap-3">
              {socialMedia.instagram && (
                <a
                  href={
                    socialMedia.instagram.startsWith("http")
                      ? socialMedia.instagram
                      : `https://instagram.com/${socialMedia.instagram.replace("@", "")}`
                  }
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group w-11 h-11 bg-white/[0.04] hover:bg-gradient-to-br hover:from-[#C9A882] hover:to-[#D4AF7A] border border-[#D4AF7A]/25 rounded-xl flex items-center justify-center text-[#D4AF7A] hover:text-black transition-all duration-300 hover:scale-110 hover:shadow-[0_0_20px_rgba(212,175,122,0.3)]"
                  aria-label="Instagram"
                >
                  <Instagram
                    size={18}
                    className="transition-transform duration-300 group-hover:scale-110"
                  />
                </a>
              )}
              {socialMedia.tiktok && (
                <a
                  href={
                    socialMedia.tiktok.startsWith("http")
                      ? socialMedia.tiktok
                      : `https://tiktok.com/${socialMedia.tiktok}`
                  }
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group w-11 h-11 bg-white/[0.04] hover:bg-gradient-to-br hover:from-[#C9A882] hover:to-[#D4AF7A] border border-[#D4AF7A]/25 rounded-xl flex items-center justify-center text-[#D4AF7A] hover:text-black transition-all duration-300 hover:scale-110 hover:shadow-[0_0_20px_rgba(212,175,122,0.3)]"
                  aria-label="TikTok"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    width="18"
                    height="18"
                    fill="currentColor"
                  >
                    <path d="M19 10.56a6.57 6.57 0 0 1-3.838-1.229v5.588a5.082 5.082 0 1 1-4.38-5.035v2.81a2.33 2.33 0 1 0 1.63 2.225V4h2.75q-.002.35.06.694A3.82 3.82 0 0 0 16.906 7.2c.621.41 1.35.629 2.094.628z" />
                  </svg>
                </a>
              )}
              {socialMedia.facebook && (
                <a
                  href={
                    socialMedia.facebook.startsWith("http")
                      ? socialMedia.facebook
                      : `https://facebook.com/${socialMedia.facebook}`
                  }
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group w-11 h-11 bg-white/[0.04] hover:bg-gradient-to-br hover:from-[#C9A882] hover:to-[#D4AF7A] border border-[#D4AF7A]/25 rounded-xl flex items-center justify-center text-[#D4AF7A] hover:text-black transition-all duration-300 hover:scale-110 hover:shadow-[0_0_20px_rgba(212,175,122,0.3)]"
                  aria-label="Facebook"
                >
                  <Facebook
                    size={18}
                    className="transition-transform duration-300 group-hover:scale-110"
                  />
                </a>
              )}
              {contactInfo.email && (
                <a
                  href={`mailto:${contactInfo.email}`}
                  className="group w-11 h-11 bg-white/[0.04] hover:bg-gradient-to-br hover:from-[#C9A882] hover:to-[#D4AF7A] border border-[#D4AF7A]/25 rounded-xl flex items-center justify-center text-[#D4AF7A] hover:text-black transition-all duration-300 hover:scale-110 hover:shadow-[0_0_20px_rgba(212,175,122,0.3)]"
                  aria-label="Email"
                >
                  <Mail
                    size={18}
                    className="transition-transform duration-300 group-hover:scale-110"
                  />
                </a>
              )}
            </div>
          </div>

          {/* ═══ Quick Links ═══ */}
          <div>
            <h4 className="text-base md:text-lg font-bold text-[#D4AF7A] mb-7 flex items-center gap-2 font-display">
              <span className="inline-block w-1 h-4 bg-gradient-to-b from-[#D4AF7A] to-[#C9A882] rounded-full" />
              Menu
            </h4>

            <ul className="space-y-2.5">
              {quickLinks.map((link) => (
                <li key={link.id}>
                  <button
                    onClick={() => scrollToSection(link.id)}
                    className="group text-[#F7F5F2]/60 hover:text-[#D4AF7A] transition-all duration-300 flex items-center gap-3 w-full text-left"
                  >
                    <span className="w-1 h-1 bg-[#D4AF7A]/50 rounded-full group-hover:bg-[#D4AF7A] group-hover:w-2 group-hover:h-2 transition-all duration-300" />
                    <span className="text-sm md:text-base">{link.label}</span>
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* ═══ Services ═══ */}
          <div>
            <h4 className="text-base md:text-lg font-bold text-[#D4AF7A] mb-7 flex items-center gap-2 font-display">
              <span className="inline-block w-1 h-4 bg-gradient-to-b from-[#D4AF7A] to-[#C9A882] rounded-full" />
              Layanan
            </h4>

            <ul className="space-y-2.5">
              {services.map((service, index) => (
                <li key={index}>
                  <button
                    onClick={() => scrollToSection("services")}
                    className="group text-[#F7F5F2]/60 hover:text-[#D4AF7A] transition-all duration-300 flex items-center gap-3 w-full text-left"
                  >
                    <span className="w-1 h-1 bg-[#D4AF7A]/50 rounded-full group-hover:bg-[#D4AF7A] group-hover:w-2 group-hover:h-2 transition-all duration-300" />
                    <span className="text-sm md:text-base">{service}</span>
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* ═══ Contact Info ═══ */}
          <div>
            <h4 className="text-base md:text-lg font-bold text-[#D4AF7A] mb-7 flex items-center gap-2 font-display">
              <span className="inline-block w-1 h-4 bg-gradient-to-b from-[#D4AF7A] to-[#C9A882] rounded-full" />
              Kontak
            </h4>

            <ul className="space-y-4">
              {contactInfo.address && (
                <li className="flex items-start gap-3 text-[#F7F5F2]/60 group">
                  <MapPin
                    size={16}
                    className="text-[#D4AF7A]/70 flex-shrink-0 mt-0.5 group-hover:text-[#D4AF7A] transition-colors duration-300"
                  />
                  <span className="text-sm md:text-base leading-relaxed group-hover:text-[#F7F5F2]/80 transition-colors duration-300">
                    {[contactInfo.address, contactInfo.city, contactInfo.region]
                      .filter(Boolean)
                      .join(", ")}
                  </span>
                </li>
              )}
              {contactInfo.whatsapp && (
                <li className="flex items-center gap-3 text-[#F7F5F2]/60 group">
                  <Phone
                    size={16}
                    className="text-[#D4AF7A]/70 flex-shrink-0 group-hover:text-[#D4AF7A] transition-colors duration-300"
                  />
                  <a
                    href={`https://wa.me/${contactInfo.whatsapp}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-sm md:text-base hover:text-[#D4AF7A] transition-colors duration-300"
                  >
                    {contactInfo.whatsapp.startsWith("0")
                      ? contactInfo.whatsapp.substring(1)
                      : contactInfo.whatsapp}
                  </a>
                </li>
              )}
              {contactInfo.email && (
                <li className="flex items-center gap-3 text-[#F7F5F2]/60 group">
                  <Mail
                    size={16}
                    className="text-[#D4AF7A]/70 flex-shrink-0 group-hover:text-[#D4AF7A] transition-colors duration-300"
                  />
                  <a
                    href={`mailto:${contactInfo.email}`}
                    className="text-sm md:text-base hover:text-[#D4AF7A] transition-colors duration-300 break-all"
                  >
                    {contactInfo.email}
                  </a>
                </li>
              )}
              {socialMedia.instagram && (
                <li className="flex items-center gap-3 text-[#F7F5F2]/60 group">
                  <Instagram
                    size={16}
                    className="text-[#D4AF7A]/70 flex-shrink-0 group-hover:text-[#D4AF7A] transition-colors duration-300"
                  />
                  <a
                    href={
                      socialMedia.instagram.startsWith("http")
                        ? socialMedia.instagram
                        : `https://instagram.com/${socialMedia.instagram.replace("@", "")}`
                    }
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-sm md:text-base hover:text-[#D4AF7A] transition-colors duration-300"
                  >
                    {socialMedia.instagram.replace("@", "")}
                  </a>
                </li>
              )}
            </ul>
          </div>
        </div>

        {/* ── Ornamental Gold Divider ── */}
        <div className="relative mb-10">
          {/* Left decorative dots */}
          <div className="absolute left-0 top-1/2 -translate-y-1/2 flex gap-1.5">
            {[0, 1, 2].map((i) => (
              <span key={i} className="w-1 h-1 rounded-full bg-[#D4AF7A]/30" />
            ))}
          </div>
          {/* Right decorative dots */}
          <div className="absolute right-0 top-1/2 -translate-y-1/2 flex gap-1.5">
            {[0, 1, 2].map((i) => (
              <span key={i} className="w-1 h-1 rounded-full bg-[#D4AF7A]/30" />
            ))}
          </div>
          {/* Gold line */}
          <div className="absolute inset-0 flex items-center">
            <div className="w-full border-t border-[#D4AF7A]/15" />
          </div>
          {/* Center ornament */}
          <div className="relative flex justify-center">
            <div className="w-32 h-[3px] bg-gradient-to-r from-transparent via-[#D4AF7A] to-transparent rounded-full" />
          </div>
        </div>

        {/* ── Bottom Bar ── */}
        <div>
          <div className="flex flex-col items-center justify-between gap-5 sm:flex-row">
            <p className="text-[#F7F5F2]/50 text-xs sm:text-sm text-center sm:text-left">
              &copy; 2025{" "}
              <span className="text-[#D4AF7A] font-medium">
                Putri Henna Artist
              </span>
              . All rights reserved.
            </p>

            <div className="flex items-center gap-4 text-xs sm:text-sm">
              <Link
                to="/privacy-policy"
                className="text-[#F7F5F2]/50 hover:text-[#D4AF7A] transition-colors duration-300"
              >
                Privacy Policy
              </Link>
              <span className="text-[#D4AF7A]/30">&bull;</span>
              <Link
                to="/terms"
                className="text-[#F7F5F2]/50 hover:text-[#D4AF7A] transition-colors duration-300"
              >
                Terms of Service
              </Link>
            </div>

            <p className="text-[#F7F5F2]/50 text-xs sm:text-sm flex items-center gap-1.5">
              Made with{" "}
              <Heart
                size={13}
                className="text-[#D4AF7A] inline-block"
                fill="#D4AF7A"
              />{" "}
              for beautiful moments
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
